import React, { useState } from 'react';
import { CopyIcon, CheckIcon } from 'lucide-react';
interface ObjectIdPillProps {
  id: string;
  className?: string;
}
export function ObjectIdPill({
  id,
  className = ''
}: ObjectIdPillProps) {
  const [copied, setCopied] = useState(false);
  const handleCopy = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <button onClick={handleCopy} className={`inline-flex items-center gap-1.5 px-2 py-1 rounded bg-muted/50 hover:bg-muted border border-border/50 text-xs font-mono text-muted-foreground hover:text-foreground transition-colors group ${className}`} title="Copy ID" data-id="element-171">
      {id}
      {copied ? <CheckIcon className="w-3 h-3 text-pk-success" data-id="element-172" /> : <CopyIcon className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-173" />}
    </button>;
}